import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function BackgroundSection() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: rightRef, isVisible: rightVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: statsRef, isVisible: statsVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="background" className="bg-cream py-24 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <span className="font-sans text-terracotta text-[11px] tracking-[0.4em] uppercase">02</span>
          <div className="flex-1 h-px bg-warm-border" />
          <span className="font-sans text-warm-muted text-[11px] tracking-[0.3em]">Why Now</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left: Text */}
          <div
            ref={leftRef}
            className={`transition-all duration-1000 ${leftVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <h2 className="font-serif text-charcoal text-2xl md:text-3xl lg:text-4xl leading-loose mb-10">
              アニメは、次の時代へ<br />進もうとしている。
            </h2>
            <div className="space-y-6 font-sans text-warm-muted text-sm md:text-base leading-loose">
              <p>
                世界のアニメ市場は拡大を続け、今やその規模は3.3兆円を超えると言われています。
                しかし日本国内の制作現場は依然として人手不足と長時間労働の課題を抱えており、
                従来の制作モデルは限界に近づいています。
              </p>
              <p>
                そこで生まれたのが、AIを活用した新しいアニメ制作のかたちです。
                Chammiは、AIツールと人間のクリエイターを組み合わせることで、
                より少ない人数でも高品質なコンテンツを生み出せる制作体制を構築しようとしています。
              </p>
              <p>
                高知県という地を選んだのは、土地のポテンシャルと、県の強力な支援があるからです。
                ここから、日本の物語を世界に届ける新しいルートを切り開きます。
              </p>
            </div>
          </div>

          {/* Right: Image */}
          <div
            ref={rightRef}
            className={`transition-all duration-1000 delay-200 ${rightVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <div className="w-full h-72 md:h-96 overflow-hidden rounded-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_8be9b4991c7f5ee342cc2f7ae9ac8233_02b1bbb4.jpg"
                alt="AIアニメ制作スタジオ"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <p className="font-sans text-warm-muted text-xs tracking-wider mt-4 text-right">
              AI × アニメ制作 — 新しい創造の形
            </p>
          </div>
        </div>

        {/* Stats */}
        <div
          ref={statsRef}
          className={`mt-20 pt-16 border-t border-warm-border grid grid-cols-1 sm:grid-cols-3 gap-12 transition-all duration-1000 ${statsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {[
            { num: '3.3兆円', label: '世界アニメ市場規模（2023年）' },
            { num: '最大60万円', label: '移住支援補助金（単身・東京から）' },
            { num: '東京・LA', label: '現在の拠点 ＋ 高知（新設）' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-serif text-terracotta text-3xl md:text-4xl mb-3">{stat.num}</p>
              <p className="font-sans text-warm-muted text-xs md:text-sm tracking-wide leading-relaxed">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
